import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./genericTableSkeleton.css";

function GenericTableSkeleton({ rowCount = 13, colCount = 6 }) {
  return (
    <div className="container-fluid my-4 generic-table-skeleton">
      {/* Skeleton for heading */}
      <h3 className="baseSkeleton nudges-skeleton-text mb-3" style={{ width: "30%" }}></h3>

      {/* Table skeleton */}
      <table className="table generic-table-skeleton-table">
        <thead>
          <tr>
            {[...Array(colCount)].map((_, colIndex) => (
              <th key={colIndex} className="baseSkeleton nudges-skeleton-text" />
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(rowCount)].map((_, rowIndex) => (
            <tr key={rowIndex}>
              {[...Array(colCount)].map((_, colIndex) => (
                <td key={colIndex}>
                  <div className="baseSkeleton nudges-skeleton-text"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default GenericTableSkeleton;
